/**
 * row-status-badge.js
 */

import React from 'react';
import { Badge } from '@mui/material';


import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  badge: {
    height: 'auto',
    minWidth: 0,
    padding: '3px 5px',
    backgroundColor: theme.palette.grey.colors[8],
    boxShadow: theme.shadows[1],
    fontSize: theme.typography.sizes[0],
    fontWeight: 'bold',
    '&.MuiBadge-anchorOriginTopRightRectangular': {
      transform: 'scale(1) translate(40%, -20%)'
    },
    '&.MuiBadge-anchorOriginBottomRightRectangular': {
      transform: 'scale(1) translate(40%, 20%)'
    }
  }
}));


export default React.forwardRef(function RowStatusBadge(props, ref) {
  const classes = useStyles();

  return (
    <Badge 
      classes={classes} 
      ref={ref}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      {...props}
    />
  );
});